import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link, useNavigate, useLocation } from "react-router-dom";
import $ from "jquery";
import { useParams } from "react-router-dom";
export const HeaderHomeSupervisor = () => {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();
  const [succ1, setsucc1] = useState(false);
  const [succ, setsucc] = useState(false);
  const [opendialogheader1, setopendialogheader] = useState(false);
  const [opendialogheader2, setopendialogheader2] = useState(false);
  const [valueUserDetail, setValuegetuser] = useState([]);
  const [showssheader, setshowssheader] = useState(false);
  const [showsisClickedopen, setshowsisClickedopen] = useState(true);
  const [notification1, setnotification1] = useState(false);
  const [Usernotification1, setUsernotification1] = useState([]);
  const [Usernotification1_total, setUsernotification1_total] = useState(0);
  const [SelectedFile_doc, setSelectedFile_doc] = useState([]);
  const [usersearch, setusersearch] = useState("");
  const [setSelectedFile_lic, setsetSelectedFile_lic] = useState(null);
  const [SelectedFile_docarray, setSelectedFile_docarray] = useState(null);
  const { code } = useParams();
  const [doc1, setdoc1] = useState("");
  const [doc2, setdoc2] = useState("");
  const [doc3, setdoc3] = useState("");
  const [doc4, setdoc4] = useState("");
  const [doc5, setdoc5] = useState("");

  const changeFavicon = (url) => {
    const favicon = document.querySelector('link[rel="icon"]');
    if (favicon) {
      favicon.href = url;
    }
  };
  const isMobileScreen = window.innerWidth <= 767.98;
  const [isDivVisible, setDivVisibility] = useState(!isMobileScreen);
  const [notificationsdetail, setnotificationsdetail] = useState([]);
  //useKeyboardShortcutBlocker();
  useEffect(() => {
    if (notificationsdetail) {
      const ws = new WebSocket("wss://jlmining.app");

      ws.onmessage = (event) => {
        try {
          const receivedMessage = JSON.parse(event.data);
          console.log(receivedMessage);

          if (receivedMessage.event === "AssignNewCourse") {
            refreshnot();
          }
        } catch (error) {
          console.error("Failed to parse WebSocket message:", error);
          console.error("Raw message:", event.data);
        }
      };

      ws.onopen = () => {
        console.log("WebSocket connection established");
      };

      ws.onerror = (error) => {
        console.error("WebSocket error:", error);
      };

      return () => {
        ws.close();
        console.log("WebSocket connection closed");
      };
    }
  }, [notificationsdetail]);
  const refreshnot = () => {
    const userStr = JSON.parse(localStorage.getItem("users"));
    let formdata = {
      user_id: userStr[0].id,
    };
    axios
      .post("https://jlmining.app/getusernotification", formdata, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        var alldata = res.data.results;
        setUsernotification1(alldata);
        var unseenCount = alldata.filter(
          (notification) => notification.status === "Unseen"
        ).length;
        setUsernotification1_total(unseenCount);
      })
      .catch((err) => { });
  };
  useEffect(() => {
    checkurl();
  }, [code]);
  const checkurl = () => {
    let formdata = {
      code: code,
    };
    axios
      .post("https://jlmining.app/api/adminsupervisor/checkcode", formdata, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        var alldata = res.data.result;
        console.log("codeeeee");
        console.log(alldata);
        if (alldata.length === 0) {
          navigate("/login");
        }
      })
      .catch((err) => { });
  };
  useEffect(() => {
    changeFavicon(require("./assets/admin/images/f-icon.png"));

    const handleResize = () => {
      const isMobile = window.innerWidth <= 767.98;
      if (isMobile !== isDivVisible) {
        setDivVisibility(!isMobile);
      }
    };

    $(window).resize(handleResize);
    alterClass();
    return () => {
      $(window).off("resize", handleResize);
    };
  }, [SelectedFile_doc]);
  const handleResize = () => {
    alterClass();
  };
  const alterClass = () => {
    const ww = document.body.clientWidth;
    if (ww < 600) {
      $(".main-admin-block").addClass("close-box");
    } else if (ww >= 601) {
      $(".main-admin-block").removeClass("close-box");
    }
  };
  const [values, setValues] = useState({
    name: "",
    email: "",
    password: "",
    contact: "",
    address: "",
  });

  const mobilepopup = () => {
    setshowsisClickedopen(!showsisClickedopen);
  };
  const fname = valueUserDetail.first_name;
  const mname = valueUserDetail.middle_name;
  const lname = valueUserDetail.last_name;
  const fLetter = fname ? fname.charAt(0) : "";
  const mLetter = mname ? mname.charAt(0) : "";
  const lLetter = lname ? lname.charAt(0) : "";
  const location = useLocation();
  const toggleDivVisibility = () => {
    setDivVisibility(!isDivVisible);
  };
  const notifica_tion = () => {
    setnotification1(!notification1);
    seeallnoti();
  };
  const closeBox = () => {
    setopendialogheader(false);
    setopendialogheader2(false);
  };
  const opendoc = () => {
    setopendialogheader(true);
  };
  const openlic = () => {
    setopendialogheader2(true);
  };
  const handleFileChange_doc1 = (event, index) => {
    if (event.target.files != null) {
      const file = event.target.files[0];
      if (index === 0) {
        setdoc1(file.name);
      }
      if (index === 1) {
        setdoc2(file.name);
      }
      if (index === 2) {
        setdoc3(file.name);
      }
      if (index === 3) {
        setdoc4(file.name);
      }
      if (index === 4) {
        setdoc5(file.name);
      }

      setSelectedFile_doc((prevFiles) => {
        const newFiles = Array.isArray(prevFiles) ? [...prevFiles] : [];
        newFiles[index] = file;
        const ss = newFiles.slice(0, 2); // Ensure array length does not exceed 2
        console.log(ss);
        return ss;
      });
    }
  };

  const handleSubmitdoc = (event) => {
    event.preventDefault();
    console.log(SelectedFile_doc);
    const userStr = JSON.parse(localStorage.getItem("users"));
    const formDataa = new FormData();
    if (SelectedFile_doc !== null) {
      if (SelectedFile_doc.length > 0) {
        for (let i = 0; i < SelectedFile_doc.length; i++) {
          formDataa.append("files", SelectedFile_doc[i]);
        }
      }
    }

    formDataa.append("user_id", userStr[0].id);
    axios
      .post("https://jlmining.app/userUpdateDocfile", formDataa, {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        console.log(res.data);
        if (res.data.status === 1) {
          setsucc(true);
          event.target.reset();
          setSelectedFile_doc([]);
          setSelectedFile_docarray([]);
          setdoc1("");
          setdoc2("");
          setdoc3("");
          setdoc4("");
          setdoc5("");
          setTimeout(() => {
            setsucc(false);
          }, 2500);
        }
      })
      .catch((err) => { });
  };
  const handleFileChange_lic = (event) => {
    if (event.target.files != null) {
      const files = event.target.files;
      setsetSelectedFile_lic(event.target.files[0]);
    }
  };
  const handleSubmitlic = (event) => {
    event.preventDefault();
    const userStr = JSON.parse(localStorage.getItem("users"));
    const vl = event.target;

    const formData = new FormData();
    formData.append("name", vl.name.value);
    formData.append("user_id", userStr[0].id);
    formData.append("licence_number", vl.licence_number.value);
    formData.append("expiryMonth", vl.expiryMonth.value);
    formData.append("expiryYear", vl.expiryYear.value);
    formData.append("file", setSelectedFile_lic);
    console.log(setSelectedFile_lic);

    axios
      .post("https://jlmining.app/useruploadlic", formData, {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        console.log(res.data);
        event.target.reset();
        setsucc1(true);
        setTimeout(() => {
          setsucc1(false);
        }, 2500);
      })
      .catch((err) => { });
  };
  const seeallnoti = () => {
    const userStr = JSON.parse(localStorage.getItem("users"));
    let formData = {
      user_id: userStr[0].id,
    };
    console.log("sddd");
    axios
      .post("https://jlmining.app/seeAllnotification", formData, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        console.log(res.data);
        setUsernotification1(res.data.results);
        var alldata = res.data.results;
        var unseenCount = alldata.filter(
          (notification) => notification.status === "Unseen"
        ).length;
        setUsernotification1_total(unseenCount);
      })
      .catch((err) => { });
  };
  const handleInput = (event) => {
    const userStr = JSON.parse(localStorage.getItem("users"));
    const vl = event.target.value;
    let userse = {
      search: vl,
    };

    setusersearch(vl);
    if (vl === "") {
      const validPaths = [
        "/currentroster",
        "/timesheet",
        "/clinetinformation",
        "/ohs",
        "/site_access",
      ];
      if (location.pathname === "/home") {
        window.location.href = "/currentroster";
      } else {
        if (validPaths.includes(location.pathname)) {
          window.location.href = location.pathname;
        }
      }
    }
    localStorage.setItem("userSearch", JSON.stringify(userse));
  };
  const handlesearch = () => {
    console.log(usersearch);

    const validPaths = [
      "/currentroster",
      "/timesheet",
      "/clinetinformation",
      "/ohs",
      "/site_access",
    ];
    if (location.pathname === "/home") {
      window.location.href = "/currentroster";
    } else {
      if (validPaths.includes(location.pathname)) {
        window.location.href = location.pathname;
      }
    }
  };
  useEffect(() => {
    const storedUsername = localStorage.getItem("userSearch");
    const userSearch = storedUsername ? JSON.parse(storedUsername) : null;
    if (userSearch !== null) {
      var ss = userSearch.search;
    } else {
      var ss = "";
    }
    setusersearch(ss);
  }, [usersearch]);
  return (
    <>
      <header
        style={{ position: "relative", left: "0", right: "0" }}
        className="d-none d-sm-block"
      >
        <div
          className="navbar-top"
          style={{ display: isDivVisible ? "none" : "block" }}
        ></div>
        <div className="container-lg">
          <div className="row gy-4 align-items-center">
            <div className="col-2 col-lg-2">
              <Link to="#" className="logo-top">
                <img src={require("./assets/images/logo2.png")} alt="logo" />
              </Link>
            </div>
            <div className="col-lg-2 d-none d-lg-block">
              <Link to="#" className="logo-top">
                <img src={require("./assets/images/hss.png")} alt="logo" />
              </Link>
            </div>
            <div className="col-9 col-lg-6 ms-auto">
              {showssheader && (
                <div className="navbar-list align-items-center  d-flex gap-3 justify-content-end">
                  <div className="input-group">
                    <input
                      required
                      onInput={handleInput}
                      value={usersearch}
                      name="searchheader"
                      type="text"
                      className="form-control"
                      placeholder="What work are you looking for today?"
                    />
                    <button
                      onClick={handlesearch}
                      type="button"
                      className="input-group-text"
                      id="basic-addon2"
                    >
                      <i className="bi bi-search search-icon searchhomenew"></i>
                    </button>
                  </div>

                  {/* User Profile Link */}
                  <p className="user-text-icon">
                    <Link to="/profile">
                      {fLetter} {lLetter}
                    </Link>
                  </p>
                  <div
                    onClick={notifica_tion}
                    className="position-relative cursor-pointer"
                  >
                    <div className="imgcount">
                      <img
                        src={require("./assets/images/3602145.png")}
                        width="30"
                        alt="Image"
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </header>
      {/* mobile header */}

      <header
        style={{ position: "relative", left: "0", right: "0" }}
        className="d-block d-sm-none "
      >
        <nav class="navbar navbar-expand-lg bg-body-tertiary">
          <div class="container-fluid">
            <div className="d-flex flex-column gap-3 w-100">
              <div class="d-flex justify-content-between w-100  gap-3  align-items-center ps-2">
                <Link to="#" className="logo-top ">
                  <img src={require("./assets/images/logo2.png")} alt="logo" />
                </Link>
                <Link to="#" className="logo-top ">
                  <img src={require("./assets/images/hss.png")} alt="logo" />
                </Link>
              </div>
            </div>
          </div>
        </nav>
      </header>
    </>
  );
};
